/**
 * @generated SignedSource<<687f717239aaaae08077bb052de4df91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddReviewResponseInput = {
  clientMutationId?: string | null;
  content: any;
  isRejected?: boolean | null;
  responseBodyHistory?: any | null;
  reviewRequestQuestionId: string;
};
export type addReviewResponseMutation$variables = {
  input: AddReviewResponseInput;
};
export type addReviewResponseMutationVariables = addReviewResponseMutation$variables;
export type addReviewResponseMutation$data = {
  readonly addReviewResponse: {
    readonly reviewResponse: {
      readonly content: any | null;
    } | null;
    readonly reviewRequestQuestion: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type addReviewResponseMutationResponse = addReviewResponseMutation$data;
export type addReviewResponseMutation = {
  variables: addReviewResponseMutationVariables;
  response: addReviewResponseMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ModernReviewRequestQuestion",
  "kind": "LinkedField",
  "name": "reviewRequestQuestion",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addReviewResponseMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddReviewResponsePayload",
        "kind": "LinkedField",
        "name": "addReviewResponse",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ModernReviewResponse",
            "kind": "LinkedField",
            "name": "reviewResponse",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addReviewResponseMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddReviewResponsePayload",
        "kind": "LinkedField",
        "name": "addReviewResponse",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ModernReviewResponse",
            "kind": "LinkedField",
            "name": "reviewResponse",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e7310bbaf0f4a100547383c528fd3302",
    "id": null,
    "metadata": {},
    "name": "addReviewResponseMutation",
    "operationKind": "mutation",
    "text": "mutation addReviewResponseMutation(\n  $input: AddReviewResponseInput!\n) {\n  addReviewResponse(input: $input) {\n    reviewResponse {\n      content\n      id\n    }\n    reviewRequestQuestion {\n      id\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "cb831500a2e95344cfa24d6712061bfd";

export default node;
